import {Col, Form, InputNumber, Row, Select, Switch} from "antd";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import DG_FormItem_LabelDetail from "../../../../../../custom/data-entry/form/Item/LabelDetail";

const {Option} = Select;

const styleFormItem = {
    labelCol: {xxl: {span: 18}, xl: {span: 18}, lg: {span: 24}},
    wrapperCol: {xxl: {span: 6}, xl: {span: 6}, lg: {span: 24}},
}

function Other(props) {
    const {t} = useTranslation();

    const [isSetting, setIsSetting] = useState(false);
    const maximumAdvanceLeave = [
        {
            name: t("tnp.components.salary.text197"),
            value: "in year"
        },
        {
            name: t("tnp.components.salary.text198"),
            value: "half year"
        },
        {
            name: t("tnp.components.salary.text199"),
            value: "quarter"
        },
        {
            name: t("tnp.components.salary.text200"),
            value: "custom"
        },
    ]
    function onChangeAllowed() {
        props.setIsAllowed(!props.isAllowed);
    }

    function onChangeSetting() {
        setIsSetting(!isSetting);
    }

    const [valueSelect, setValueSelect] = useState([]);
    const selectProps = {
        mode: 'multiple',
        style: {
            width: '100%',
        },
        valueSelect,
        onChange: (newValue) => {
            setValueSelect(newValue);
        },
        maxTagCount: 'responsive',
        allowClear: true,
    }

    useEffect(() => {
        setIsSetting(props.isSetting)
    }, [props.isSetting]);

    const [typeMaximumAdvanceLeave, setTypeMaximumAdvanceLeave] = useState("")
    const chooseTypeMaximumAdvanceLeave = (value) => {
        setTypeMaximumAdvanceLeave(value)
    }

    const mapSelectMaximumAdvanceLeave = maximumAdvanceLeave.map(item => <Option value={item.value}>{item.name}</Option>)

    const filterOption = (input, option) => {
        const normalizedInput = input.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const normalizedOption = option?.dataSearch.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        return normalizedOption.includes(normalizedInput);
    };

    return (
        <div id={props.id} className={'px-4'}>
            <Row gutter={12} style={{marginBottom: "10px"}}>
                <Col span={24}>
                    <div className={"flex__align--center"}>
                        <Form.Item
                            name={"allowedAdvanceLeave"}
                            valuePropName={"checked"}
                            initialValue={false}
                            className={"margin--0"}
                        >
                            <Switch onChange={onChangeAllowed}/>
                        </Form.Item>
                        <span className={"px-4"}>
							{t("leave-setting.allowedLeave")}
						</span>
                    </div>
                </Col>
            </Row>
            {props.isAllowed && <div id="allowed-leave">
                <Row gutter={12}>
                    <Col span={24}>
                        <p className={"margin__y--10 char--gray"}>
                            {t("leave-setting.allowedLeaveDetails1")}
                        </p>
                        <p className={"margin__y--10 char--gray"}>
                            {t("leave-setting.allowedLeaveDetails2")}
                        </p>
                    </Col>
                </Row>
                <Row gutter={12}>
                    <Col span={1}/>
                    <Col span={23}>
                        <DG_FormItem_LabelDetail
                            label={t("leave-setting.allowContractType")}
                            labelDetail={`
                                ${t("leave-setting.allowContractTypeDetails1")}
                                ${t("leave-setting.allowContractTypeDetails2")}
                                ${t("leave-setting.allowContractTypeDetails3")}
                            `}
                            name={"contractTypeAdvanceIds"}
                            style={{height: "150px"}}
                            {...styleFormItem}
                        >
                            <Select
                                placeholder={t("leave-setting.chooseContractType")}
                                showSearch
                                optionFilterProp="children"
                                filterOption={filterOption}
                                allowClear
                                {...selectProps}
                            >
                                {props.dataSelectContractTypeAdvance}
                            </Select>
                        </DG_FormItem_LabelDetail>
                    </Col>
                </Row>
                <Row gutter={12}>
                    <Col span={1}/>
                    <Col span={23}>
                        <DG_FormItem_LabelDetail
                            label={t("leave-setting.maximumLeaveApplied")}
                            labelDetail={t("leave-setting.maximumLeaveAppliedDetails")}
                            name={"maximumAdvanceLeave"}
                            initialValue={"in year"}
                            {...styleFormItem}
                        >
                            <Select
                                onChange={(e) => chooseTypeMaximumAdvanceLeave(e)}
                            >
                                {mapSelectMaximumAdvanceLeave}
                            </Select>
                        </DG_FormItem_LabelDetail>
                    </Col>
                </Row>
                {
                    typeMaximumAdvanceLeave === "custom" || props.maximumAdvanceLeaveProps === "custom"
                        ? <Row gutter={12}>
                            <Col span={1}/>
                            <Col span={23}>
                                <Form.Item
                                    labelCol={{
                                        xxl: {span: 18},
                                        xl: {span: 18},
                                        lg: {span: 24},
                                    }}
                                    wrapperCol={{
                                        xxl: {span: 6},
                                        xl: {span: 6},
                                        lg: {span: 24},
                                    }}
                                    label={
                                        <div className="margin-b-5">
                                            {t("leave-setting.advanceLeave")}
                                        </div>
                                    }
                                    name={"advanceLeave"}
                                >
                                    <InputNumber/>
                                </Form.Item>
                            </Col>
                        </Row>
                        : <></>
                }
                <Row gutter={12}>
                    <Col span={1}/>
                    <Col span={23}>
                        <DG_FormItem_LabelDetail
                            label={t("leave-setting.monthSeniorytiApllied")}
                            labelDetail={`${t("leave-setting.monthSeniorytiAplliedDetails1")}
                                ${t("leave-setting.monthSeniorytiAplliedDetails2")}
                            `}
                            name={"seniorityAdvanceLeave"}
                            {...styleFormItem}
                        >
                            <InputNumber style={{width: "100%"}}/>
                        </DG_FormItem_LabelDetail>
                    </Col>
                </Row>
            </div>}
            {/*<Row gutter={12} style={{marginBottom: "10px"}}>*/}
            {/*    <Col span={24}>*/}
            {/*        <div className={"flex__align--center"}>*/}
            {/*            <Form.Item*/}
            {/*                name={"settingMaternity"}*/}
            {/*                valuePropName={"checked"}*/}
            {/*                initialValue={false}*/}
            {/*                className={"margin--0"}*/}
            {/*            >*/}
            {/*                <Switch onChange={onChangeSetting}/>*/}
            {/*            </Form.Item>*/}
            {/*            <span className={"margin__x--10"}>*/}
            {/*                {t("leave-setting.maternityLeaveNoCounted")}*/}
            {/*            </span>*/}
            {/*        </div>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            {/*{isSetting && <div id="setting-maternity">*/}
            {/*    <Row gutter={12}>*/}
            {/*        <Col span={1}/>*/}
            {/*        <Col span={23}>*/}
            {/*            <DG_FormItem_LabelDetail*/}
            {/*                label={t("leave-setting.materinityCountedAfter")}*/}
            {/*                labelDetail={""}*/}
            {/*                name={"maternityOffOnLeave"}*/}
            {/*                {...styleFormItem}*/}
            {/*            >*/}
            {/*                <InputNumber style={{width: "100%"}}/>*/}
            {/*            </DG_FormItem_LabelDetail>*/}
            {/*        </Col>*/}
            {/*    </Row>*/}
            {/*    <Row gutter={12}>*/}
            {/*        <Col span={1}/>*/}
            {/*        <Col span={23}>*/}
            {/*            <DG_FormItem_LabelDetail*/}
            {/*                label={t("leave-setting.materinityCountedBefore")}*/}
            {/*                labelDetail={""}*/}
            {/*                name={"maternityBackOnLeave"}*/}
            {/*                {...styleFormItem}*/}
            {/*            >*/}
            {/*                <InputNumber style={{width: "100%"}}/>*/}
            {/*            </DG_FormItem_LabelDetail>*/}
            {/*        </Col>*/}
            {/*    </Row>*/}
            {/*</div>}*/}
        </div>
    );
}

export default Other;
